<template>
  <div class="head-container">
    <div class="header-content">
      <!-- 左侧：系统标题 -->
      <div class="title-section">
        <div class="main-title">
          <i class="el-icon-search title-icon"></i>
          <span>万能快查</span>
        </div>
        <div class="subtitle">简单易用的个性化数据查询服务！</div>
      </div>

      <!-- 右侧：操作区域 -->
      <div class="action-section">
        <el-button
          @click="logout"
          type="text"
          size="medium"
          class="logout-button">
          <i class="el-icon-switch-button"></i>
          <span>退出</span>
        </el-button>
      </div>
    </div>

    <!-- 修改用户资料对话框 -->
    <el-dialog
      width="30%"
      :close-on-click-modal="false"
      title="修改用户资料"
      :visible.sync="editDialogVisible"
      class="edit-dialog">
      <div class="dialog-body">
        <div class="edit-form">
          <div class="form-row">
            <span class="form-label">{{lable}}</span>
            <el-input
              v-model="content"
              autocomplete="off"
              placeholder="请输入内容"
              autofocus
              class="form-input">
            </el-input>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelEdit" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="saveContent" class="save-btn">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      name: '',
      school: '',
      content: '',
      lable: '',
      source: '',
      editDialogVisible: false,
      url: this.HOST_URL + '/images/logo.jpg'
    }
  },
  created() {
    this.username = this.$session.get('USERNAME') // 获取session
    this.name = this.$session.get('NAME') // 获取session
  },
    mounted() {
    console.log('monted:' + this.username)
    if (this.isEmpty(this.username)) {
      this.$router.push('/')
    }
    },
  methods: {
    logout() {
      let that = this

      this.$confirm('要退出系统吗?', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var requestUrl = '/wansearch/web/_logout.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            that.$session.set('USERNAME', '')
            that.$router.push('/')
          })
          .catch(function(error) {
            console.log(error)
          })
      }).catch(() => {

      })
    },
    helpMe() {
      const {
        href
      } = this.$router.resolve({
        name: 'help'
      })
      window.open(href, '_blank')
    },
    editProfile(source) {
      if (source === 'school_name') {
        this.content = this.school
        this.lable = '学校'
        this.source = 'school_name'
      } else {
        this.content = this.teacher_name
        this.lable = '姓名'
        this.source = 'teacher_name'
      }

      this.editDialogVisible = true
    },
    cacelEdit() {
      this.editDialogVisible = false
    },
    saveContent() {
      // 校验
      if (this.content === '') {
        this.$message.error('内容不能为空！')
        return
      }

      let that = this
      var requestUrl = '/wansearch/web/_update_profile.jsp'

      if (this.source === 'school_name') {
        this.school = this.content
        that.$session.set('SCHOOL', this.content) // 存session
      } else {
        this.teacher_name = this.content
        that.$session.set('TEACHER_NAME', this.content) // 存session
      }

      // 设置session

      this.axios.get(requestUrl, {
          params: {
            username: that.username,
            content: that.content,
            source: that.source
          }
        }).then(function(response) {
          // that.columNames.push(...response.data)
          that.content = ''
          that.editDialogVisible = false
          that.$message('修改成功！')
        })
        .catch(function(error) {
          console.log(error)
        })
    }

  }
}
</script>

<style scoped>
/* ==================== 头部容器 ==================== */
.head-container {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 100;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 30px;
  max-width: 100%;
}

/* ==================== 标题区域 ==================== */
.title-section {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.main-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 1px;
}

.title-icon {
  font-size: 26px;
  color: #667eea;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

.subtitle {
  font-size: 13px;
  color: #7f8c8d;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin-left: 36px;
}

/* ==================== 操作区域 ==================== */
.action-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logout-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border-radius: 8px;
  color: #495057;
  font-size: 14px;
  font-weight: 500;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.logout-button:hover {
  background: #667eea;
  color: #ffffff;
  border-color: #667eea;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.logout-button:active {
  transform: translateY(0);
}

.logout-button i {
  font-size: 15px;
}

/* ==================== 对话框样式 ==================== */
.edit-dialog >>> .el-dialog {
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.edit-dialog >>> .el-dialog__header {
  background: #ffffff;
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.edit-dialog >>> .el-dialog__title {
  color: #2c3e50;
  font-size: 18px;
  font-weight: 600;
}

.edit-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #7f8c8d;
  font-size: 20px;
}

.edit-dialog >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #667eea;
}

.edit-dialog >>> .el-dialog__body {
  padding: 30px 20px;
}

.dialog-body {
  padding: 10px;
}

/* ==================== 表单样式 ==================== */
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  min-width: 80px;
  text-align: right;
}

.form-input {
  flex: 1;
}

.form-input >>> .el-input__inner {
  font-size: 14px;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  padding: 11px 15px;
  transition: all 0.3s ease;
}

.form-input >>> .el-input__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

/* ==================== 对话框底部按钮 ==================== */
.dialog-footer {
  padding: 15px 20px 20px 20px;
  background: #f8f9fa;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  background: #ffffff;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #f8f9fa;
  color: #2c3e50;
  border-color: #dee2e6;
}

.save-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: #ffffff;
  transition: all 0.3s ease;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.save-btn:active {
  transform: translateY(0);
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 768px) {
  .header-content {
    padding: 15px 20px;
  }

  .main-title {
    font-size: 20px;
  }

  .title-icon {
    font-size: 22px;
  }

  .subtitle {
    font-size: 12px;
    margin-left: 32px;
  }

  .logout-button {
    padding: 7px 14px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 12px 15px;
  }

  .main-title {
    font-size: 18px;
  }

  .title-icon {
    font-size: 20px;
  }

  .subtitle {
    font-size: 11px;
    margin-left: 30px;
  }

  .logout-button {
    padding: 6px 12px;
    font-size: 12px;
  }

  .logout-button span {
    display: none;
  }

  .form-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .form-label {
    text-align: left;
    min-width: auto;
  }

  .edit-dialog {
    width: 90% !important;
  }

  .dialog-footer {
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue